import type { Nebula, Scene, Star, FeatureKind } from "./types";
import { seededGen } from "./rng";

/**
 * Cada ola es un sector distinto, generado desde el numero de ola. La misma ola
 * siempre da el mismo sector: variedad reproducible, no ruido aleatorio.
 */

const FEATURES: FeatureKind[] = ["spiral", "giant", "dust", "storm"];

const SECTOR_NAMES = [
  "Confin de Ceres",
  "Deriva de Vela",
  "Puerta Kuiper",
  "Cinturon Hesperus",
  "Umbral de Tycho",
  "Grieta de Orfeo",
  "Bajio del Nadir",
  "Espuela de Carina",
  "Extension del Lete",
  "Pliegue de Kepler",
];

export function sceneFor(wave: number): Scene {
  const R = seededGen(wave * 7919 + 13);
  const hue = Math.floor(R() * 360);
  const hue2 = Math.floor((hue + 90 + R() * 140) % 360);

  const blobs: Nebula[] = [];
  for (let i = 0; i < 3; i++) {
    blobs.push({
      x: 0.1 + R() * 0.8,
      y: 0.05 + R() * 0.7,
      r: 0.35 + R() * 0.55,
      h: i ? hue2 : hue,
      a: 0.05 + R() * 0.07,
    });
  }

  const stars: Star[] = [];
  for (let i = 0; i < 190; i++) {
    stars.push({ x: R(), y: R(), z: 0.12 + R() * 0.88, tw: R() * 6.28 });
  }

  return {
    wave,
    hue,
    hue2,
    blobs,
    stars,
    feature: FEATURES[(wave - 1) % FEATURES.length]!,
    fx: 0.12 + R() * 0.76,
    fy: 0.1 + R() * 0.42,
    fs: 0.6 + R() * 0.9,
    frot: R() * 6.28,
    name: SECTOR_NAMES[(wave - 1) % SECTOR_NAMES.length]!,
  };
}

export const ROMAN = [
  "",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "XI",
  "XII",
];

export const sectorNumeral = (wave: number): string => ROMAN[((wave - 1) % 12) + 1]!;
